export default {
  date: 'YYYY-MM-DD',
  dateTimeWithSeconds: 'DD/MM/YYYY HH:mm:ss',
};
